<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
import {getLang} from "@/lang/utils";

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  created() {
    this.$i18n.locale = getLang()
    // this.$message({
    //   showClose: true,
    //   message: '网站维护中..',
    //   type: 'warning',
    //   duration: 0
    // });
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>


<style lang="scss">
@import "assets/css/reset.css";
:root {
  --current-font-color: #F5F5F6;
  --current-card-color: #1C1C27;
  --current-bg-color: #141128;
  --current-border-color: #A5A4AC;
  --current-primary-color: #6B4EE7;
  --current-aside-color: #2A273D;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
